// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__gTbuC","title":"ClientCherryInfo_title__FvqgV","itemText":"ClientCherryInfo_itemText__ZMWRo"};